import React, {SyntheticEvent} from 'react';
import ModalV4 from '../../../app/ui/modal/v4/v4';
import ItemViewTop from "../../../layout/top/item-view-top/item-view-top";
import ErrorBoundary from "../../error-boundary";
import ButtonSubmit from "../../gd-form/common/btn-submit/btn-submit-ui5-new";
import AttendanceEvent from "../../model2/attendance-event/attendance-event";
import FormModel from "../../gd-form/common/form-model-manager";
import FieldFormElement from "../../fields3/render/form-elemnent";
import AttendanceFields from "../../model2/attendance-event/fields";
import FormFlex from "../../gd-form/form/form-flex/form";
import FormRowFlex from "../../gd-form/form/form-flex/row";

export default class ModalClockOut extends ModalV4 {

    public clockOutForm         : FormModel
    public clockOutEvent        : AttendanceEvent
    public fields               : AttendanceFields  = new AttendanceFields()

    constructor(props: any) {
        super(props);

        this.clockOutEvent  = new AttendanceEvent({})
        this.clockOutForm   = new FormModel(this.clockOutEvent,{
            onSubmit: this.props.params.onSubmit
        })
    }

    onClick = (e: SyntheticEvent) => {
        e.stopPropagation();
        e.preventDefault();
    }

    render() {
        const topLeftContent = <div className="ui5-txt-not-important-small">Clock out</div>

        return (
            <div className="v4-container placement-middle ui5-iv" style={{width: 840, height: 600}} onClick={this.onClick}>
                <ItemViewTop leftContent={topLeftContent} onCloseClick={this.closeModal}/>
                <div className="iv-left-column iv-column">
                    <div className="details-big-icon">
                        <div className="isvg isvg-clock-in-out"/>
                    </div>
                </div>
                <ErrorBoundary>
                    <div className="iv-cf-form">
                        <div className="iv-header header-left header-small-no-separator m-t-30 m-l-20 ">
                            <div className="title-line">
                                <div className="view-name">
                                    <div className="ui5-title-app-name max-w-350">Clock Out</div>
                                </div>
                            </div>
                        </div>

                        <div className="iv-content with-left-panel">
                            <div className="p-l-30">
                                <FormFlex className="m-t-40 m-l-20">
                                    <FormRowFlex label="Comment" field={this.fields.officeId} form={this.clockOutForm}>
                                        <FieldFormElement form={this.clockOutForm}
                                                          field={this.fields.comment}
                                                          model={this.clockOutEvent}
                                                          className="w-300"/>
                                    </FormRowFlex>
                                    <FormRowFlex width={150} form={this.clockOutForm}>
                                        <ButtonSubmit form={this.clockOutForm} className="submit w-100" label="Submit"/>
                                    </FormRowFlex>
                                </FormFlex>

                            </div>
                        </div>
                    </div>
                </ErrorBoundary>
            </div>
        )
    }
}
